import { ADD_TOAST, LOGIN_SUCCESS, REMOVE_TOAST } from "../actions/constants";

export interface ToastsState {
  toasts: [];
}

export const initialState: ToastsState = {
  toasts: [],
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ADD_TOAST:
      return {
        ...state,
        toasts: state.toasts.concat(action.payload),
      };
    case REMOVE_TOAST:
      return {
        ...state,
        toasts: state.toasts.filter(
          (toast: any) => toast.id !== action.payload
        ),
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        toasts: [],
      };
    default:
      return state;
  }
};
export default reducer;
